import { v4 as uuidV4 } from 'uuid';
import { throttle } from 'lodash-es';
import nimitt, { getHealthStatus, setHealthStatus } from './nimitt';
import { doNimHealthSend } from './nimHealthSend';

let healthTimeout: ReturnType<typeof setInterval>;
const duration = 60 * 1000;
const sendHealthReq = throttle(() => {
  const uuid = uuidV4();
  const cb = (p: any) => {
    if (uuid === p?.uuid) {
      setHealthStatus('alive');
      off?.();
      off = null;
    }
  };
  nimitt.on('sys:message:health_ack', cb);
  let off: null | (() => void) = () => nimitt.off('sys:message:health_ack', cb);
  setTimeout(() => {
    if (off) {
      setHealthStatus('timeout');
      off();
      off = null;
    }
  }, duration);
  doNimHealthSend(uuid)
    .then(() => {
      const lastStatus = getHealthStatus();
      // 如果上次心跳没有异常，优先保留alive状态
      setHealthStatus(lastStatus === 'alive' ? 'alive' : 'pending');
    })
    .catch((e: any) => {
      setHealthStatus('error');
    });
}, duration);

nimitt.on('connect', () => {
  clearInterval(healthTimeout);
  sendHealthReq();
  healthTimeout = setInterval(sendHealthReq, duration);
});

nimitt.on('error', () => {
  clearInterval(healthTimeout);
  setHealthStatus('ideal');
});
nimitt.on('disconnect', () => {
  clearInterval(healthTimeout);
  setHealthStatus('ideal');
});
nimitt.on('willReconnect', () => {
  clearInterval(healthTimeout);
  setHealthStatus('ideal');
});
